import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap, catchError, merge, map } from 'rxjs/operators';
import { OperateursService } from 'src/app/data/intervenant/services/operateurs/operateurs.service';
import { Operateur } from 'src/app/data/intervenant/models/operateur.model';
import { Router, ActivatedRoute } from '@angular/router';
import { JsonMapperService } from '../../../../../core/services/mapper/mapper.service';
import { NavigationContext } from '../../../../../core/services/config/app.settings';

@Component({
    selector: 'app-recherche-operateur-affilie',
    templateUrl: './recherche-operateur-affilie.component.html',
    styleUrls: ['./recherche-operateur-affilie.component.scss'],
    standalone: false
})
export class RechercheOperateurAffilieComponent implements OnInit {
    placeholder: string;
    minLength = 2;

    searching = false;
    noResult = false;
    userSearch: string;

    constructor(
        private readonly operateursService: OperateursService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        protected readonly mapper: JsonMapperService
    ) {}

    focus$ = new Subject<string>();
    @ViewChild('someInput', { static: true }) searchElement: ElementRef;
    search = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            merge(this.focus$),
            tap(() => {
                this.searching = true;
                this.noResult = false;
            }),
            switchMap(term => {
                if (term != null && term.length >= this.minLength) {
                    return this.operateursService.getOperateursAffilies(term).pipe(
                        switchMap(operateurs => {
                            if (!operateurs || operateurs.length === 0) {
                                this.noResult = true;
                                return of([]);
                            }
                            return this.operateursService.getInformationsDomaineByIdsOperateur(operateurs).pipe(
                                map(domaines => {
                                    return operateurs.map(operateur => {
                                        const matching = domaines.find(d => d.idOperateur === operateur.id);
                                        const numeroCVI = matching && matching.domaines ? matching.domaines.find(d => d.code === 'VIN_CVI') : null;
                                        return {
                                            ...operateur,
                                            numeroCVI: numeroCVI && numeroCVI.valeur ? numeroCVI.valeur : null
                                        };
                                    });
                                })
                            );
                        }),
                        catchError(() => {
                            this.noResult = true;
                            return of([]);
                        })
                    );
                } else {
                    return of([]);
                }
            }),
            tap(() => (this.searching = false))
        );
    formatter = (operateur: Operateur) => {
        const prenom = operateur.prenom ? operateur.prenom.toUpperCase() : '';
        const nom = operateur.nom ? operateur.nom.toUpperCase() : '';
        const raisonSociale = operateur.raisonSociale ? operateur.raisonSociale.toUpperCase() : `${prenom} ${nom}`;
        const numeroCVI = operateur.numeroCVI ? operateur.numeroCVI : '';
        const ville = operateur.ville ? operateur.ville.toUpperCase() : '';

        return `${raisonSociale} (CVI: ${numeroCVI} - à ${ville})`;
    };

    selectOperateur(event) {
        if (event.item != null) {
            const operateur = event.item as Operateur;
            this.operateursService.setIdOperateur(operateur.id);
            NavigationContext.set('idOperateur', operateur.id);
            this.router.navigate([operateur.id], { relativeTo: this.route.parent });
        }
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.userSearch = params.search;
            setTimeout(() => {
                this.searchElement.nativeElement.focus();
            }, 100);
        });
    }
}
